import { ProductType, RouteName } from '@/shared/enums';
import { services } from '@/shared/plugins/services';
import { getMainCategoryLabel } from '@/shared/utils';

const liveManager = services.resolve('liveManager');

const link = (product = {}) => {
  if (!product.id) {
    return {};
  }

  if (product.type === ProductType.BANNER && product.urlWeb) {
    return product.urlWeb;
  }

  let name;
  let params;

  switch (product.type) {
    case ProductType.VOD:
      name = RouteName.DETAIL;
      params = {
        label: getMainCategoryLabel(product),
        slug: product.slug,
        type: ProductType.VOD,
        id: product.id,
      };
      break;
    case ProductType.LIVE:
      name = RouteName.DETAIL;
      params = {
        label: getMainCategoryLabel(product),
        slug: product.slug,
        type: ProductType.LIVE,
        id: product.id,
      };
      break;
    case ProductType.PROGRAMME:
      const channel = liveManager.channels.get(product.channelId);

      name = RouteName.DETAIL_WITH_ARTICLE;
      params = {
        label: getMainCategoryLabel(channel),
        slug: channel.slug,
        type: ProductType.LIVE,
        id: channel.id,
        articleSlug: product.slug,
        articleType: ProductType.PROGRAMME,
        articleId: product.id,
      };
      break;
    case ProductType.SERIAL:
      name = RouteName.DETAIL;
      params = {
        label: getMainCategoryLabel(product),
        slug: product.slug,
        type: ProductType.SERIAL,
        id: product.id,
      };
      break;
    case ProductType.EPISODE:
      const serial = product.season.serial;

      name = RouteName.DETAIL_WITH_ARTICLE;
      params = {
        label: getMainCategoryLabel(serial),
        slug: serial.slug,
        type: ProductType.SERIAL,
        id: serial.id,
        articleSlug: product.slug,
        articleType: ProductType.EPISODE,
        articleId: product.id,
      };
      break;
    case ProductType.CLIP:
      name = RouteName.DETAIL;
      params = {
        label: getMainCategoryLabel(product),
        slug: product.slug,
        type: ProductType.CLIP,
        id: product.id,
      };
      break;
  }

  Object.keys(params).forEach((key) => {
    if (typeof params[key] === 'string') {
      params[key] = params[key].toLowerCase();
    }
  });

  return {
    name,
    params,
  };
};

export default link;
